module.exports = __webpack_public_path__ + "static/media/logoorange.06be4581.png";